import React from "react"

const ResponsiveLayoutSection = (props) => (
  <section id={props.sectionId} className="section-block" data-scroll-index={props.dataScrollNav}>
    {props.children}
  </section>
)

export default ResponsiveLayoutSection
